import { useIdFilter } from "shared-ts/hooks/useFilter"
import { stringComparator } from "shared-ts/utils/sorting/comparators"

import { useListProductCategoriesForCompanyV2Query } from "features/api/company"
import { classFilterKey } from "hooks/filters/filterKeys"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export { classFilterKey }

export function useClassFilter({
  persistInUrl = true,
}: Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl">> = {}) {
  const { data } = useListProductCategoriesForCompanyV2Query({})

  const { filter, selected: selectedClassIds } = useIdFilter({
    key: classFilterKey,
    label: "Class",
    values: data?.classes ?? [],
    sort: stringComparator((category) => category.name),
    labelExtractor: (c) => c.name,
    useFilter: (props) => useWebFilter({ ...props, persistInUrl }),
  })

  return { filter, selectedClassIds }
}
